import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { FrontHeader } from '@app/src/app/components/front-header/front-header';
import { ContentFlex, RenderHtml, Translation } from '@ckmk/angular';
import { ContactForm } from '@app/src/app/components/contact-form/contact-form';

@Component({
  selector: 'contact',
  standalone: true,
  imports: [FrontHeader, Translation, RenderHtml, ContactForm, ContentFlex],
  templateUrl: './contact.html',
  styleUrl: './contact.scss',
  encapsulation: ViewEncapsulation.None,
})
export class Contact implements OnInit, OnChanges, OnDestroy, AfterContentInit {
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  public constructor() {}

  public ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy() {}

  public ngAfterContentInit() {}
}
